import { State as StateDef, ResolveTypegenMeta, BaseActionObject } from 'xstate';
import type * as NavigationMenu from './navigationMenu.types';
import { Typegen0 } from './navigationMenu.machine.typegen';
import { getStatePath } from '../util';

// [NOTE] - Normally we can use some util helpers, other TS access to get this
//          but it's possible to run into a circular dependency error when using selector as machine guards
//        - This probably creates a 2nd instance of the State type but it's needed for now
type State = StateDef<
  NavigationMenu.SMContext,
  NavigationMenu.SMEvents,
  any,
  { value: any, context: NavigationMenu.SMContext },
  ResolveTypegenMeta<
    Typegen0,
    NavigationMenu.SMEvents,
    BaseActionObject,
    NavigationMenu.SMServices
  >
>

// MACHINE
export const isIdleState = (state: State) => ({ isIdleState: state.matches('ready') });
export const isInViewerView = (state: State) => {
  const statePath = getStatePath(state.machine?.id ?? '', state.historyValue?.current);
  return { isInViewerView: statePath.includes('viewer') }
};
export const isInPublisherView = (state: State) => {
  const statePath = getStatePath(state.machine?.id ?? '', state.historyValue?.current);
  return { isInPublisherView: statePath.includes('publisher') }
};

// CONTEXT
export const isMenuCollapsed = (state: State) => ({ isMenuCollapsed: state.context.collapsed });
export const currentRoute = (state: State) => ({ currentRoute: state.context.currentRoute });

export const displayingNavigationItems = (state: State) => {
  const allNavigationItemsConfig = state.context.allNavigationItemsConfig;
  const _isInViewerView = isInViewerView(state).isInViewerView;
  const displayingNavigationItems = allNavigationItemsConfig[_isInViewerView ? 'viewer' : 'publisher']
    .filter((item) => item.condition).map((item) => {
      return {
        ...item,
        children: item.children?.filter((child) => child.condition),
      }
    });
  return { displayingNavigationItems };
};

export const shouldExpandChildren = (state: State) => {
  const _isMenuCollapsed = isMenuCollapsed(state).isMenuCollapsed;
  const _currentRoute = currentRoute(state).currentRoute;

  function isExpandedOrIsParentOfCurrentRoute(
    currentNavigationItemConfig: NavigationMenu.NavigationItemConfig,
  ): boolean {
    return !_isMenuCollapsed &&
      !!currentNavigationItemConfig.children?.some(child => child.route.PATH === _currentRoute?.PATH);
  }
  const _shouldExpandChildren =
    (currentNavigationItemConfig) => isExpandedOrIsParentOfCurrentRoute(currentNavigationItemConfig);
  return { shouldExpandChildren: _shouldExpandChildren };
};
